import { render, staticRenderFns } from "./r-color-picker.vue?vue&type=template&id=6ce5105a"
import script from "./r-color-picker.vue?vue&type=script&lang=js"
export * from "./r-color-picker.vue?vue&type=script&lang=js"
import style0 from "./r-color-picker.vue?vue&type=style&index=0&id=6ce5105a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./r-color-picker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports